import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { ITranslateCollectionParams } from './translate-collection-request';

export async function translateCollectionApi({
  collectionId,
  langs,
  limit,
  force,
}: ITranslateCollectionParams): Promise<Response> {
  const body: Record<string, unknown> = {};
  if (langs?.length) {
    body.langs = langs;
  }
  if (limit) {
    body.limit = limit;
  }
  if (force) {
    body.force = true;
  }

  return postRawRequest({
    path: `/sys/pipeline/${collectionId}/translate`,
    body,
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
